<template>
  <AppInputField :class="inputVariant">
    <!-- input control -->
    <div class="app-input-field__control" :class="[prependClass, appendClass, floatingLabelClass]">
      <!-- prepend icon -->
      <div v-if="prependIcon" class="prepend-icon" @click="iconClicked" data-icon="prepend">
        <AppIcon :icon="prependIcon" />
      </div>
      <input
        v-bind="$attrs"
        v-on="{
          ...$listeners,
          input: updateValue,
        }"
        class="app-input"
        :value="value"
        :class="[filledClass, inputType]"
      />
      <label v-if="label" :for="$attrs.id">{{ label }}</label>
      <!-- append icon -->
      <div v-if="appendIcon" class="append-icon" @click="iconClicked" data-icon="append">
        <AppIcon :icon="appendIcon" />
      </div>
    </div>
  </AppInputField>
</template>

<script>
// Utils
import appInputs from 'Mixins/Forms/appInputs'
// Components
import AppIcon from 'Ui/AppIcon'
import AppInputField from 'Ui/AppInputField'

export default {
  name: 'AppInput',

  inheritAttrs: false,

  components: {
    AppIcon,
    AppInputField,
  },

  mixins: [appInputs],
}
</script>

<style scoped>
/* COMMON STYLES */
.app-input-field--filled .app-input-field__control,
.app-input-field .app-input-field__control:not(.floating-label) {
  display: flex;
  flex-flow: column-reverse;
  align-items: flex-start;
  gap: 5px;
}

/* FILLED STYLES */
.app-input-field--filled .app-input {
  border: none;
  box-shadow: none;
  background-color: var(--c-secondary-300);
  padding: 5px 10px;
}

.app-input-field--filled:focus-within input {
  box-shadow: 0 2px 10px -5px var(--c-secondary);
}
</style>
